import constants from "../constants.js";


const CtmHotelReviewSearch = {
  displayName: 'Hotel Reviews',
  iconClass: 'fa-hotel',
  displayAs: constants.DISPLAY_AS.HOTEL_REVIEW
}

const CTMHotelReviewSearchTab = {
  dataAt: '',
  tabName: 'Search',
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [CtmHotelReviewSearch]
};


const CtmHotelReviewsList = {
  displayName: "Debtor Hotel Reviews",
  endpoint: "DebtorProducts",
  ODataArgs: `?$select=DebtorIdentifier,Type,Enabled&$filter=Type eq '${constants.PRODUCT.HOTELREVIEW}' and IsDeleted eq false`,
  displayAs: constants.DISPLAY_AS.GRID,
  iconClass: "fa-comments",
  gridCols: [
    { name: "Debtor", key: "DebtorIdentifier" },
    { name: "Product", key: "Type" },
    { name: "Enabled", key: "Enabled" },
  ],
};


const CTMHotelReviewTab = {
  dataAt: '',
  tabName: 'Settings',
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [CtmHotelReviewsList]
};

const HotelReviewsTabs = {
  displayName: "Hotel Reviews",
  iconClass: "fa-hotel",
  displayAs: constants.DISPLAY_AS.TABS,
  children: [CTMHotelReviewTab, CTMHotelReviewSearchTab],
};


const HotelReviewsResource = {
  rootNode: true,
  displayName: "Hotel Reviews",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  ODataArgs: `?$select=DebtorIdentifier,Type,Enabled&$filter=Type eq '${constants.PRODUCT.HOTELREVIEW}' and IsDeleted eq false`,
  iconClass: "fa-hotel",
  dataAt: "",
  endpoint: 'DebtorProducts',
  children: [HotelReviewsTabs],
};

export default {
  HotelReviewsResource,
};



// WEBPACK FOOTER //
// ./src/config/fields/hotelReviews.js